import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Contact } from '../../../../../../data/models';
import { LayoutService } from '../../../../layout.service';
import { MenubarCollapseComponent } from '../../menubar-collapse/menubar-collapse.component';
import { MenuName } from '../../menubar-scroll/menubar-menu-type.model';
import { MenubarScrollComponent } from '../../menubar-scroll/menubar-scroll.component';
import { NavMenuItem } from '../../menubar/domain/entities/menu-item.model';
import { MenubarComponent } from '../../menubar/menubar.component';
import { SecondaryNavService } from '../../secondary-nav.service';
import { SecondaryNavStoreService } from '../../secondary-nav.store.service';
import { TopbarInfoComponent } from '../../topbar-info/topbar-info.component';
import { TopnavComponent } from '../../topnav/topnav.component';
import { SecondaryNavContactService } from '../secondary-nav-contact.service';
import { TopbarContactInfoComponent } from '../topbar-contact-info/topbar-contact-info.component';
import { Router } from '@angular/router';
@UntilDestroy()
@Component({
    selector: 'app-secondary-nav-contacts',
    templateUrl: './secondary-nav-contacts.component.html',
    styleUrls: ['./secondary-nav-contacts.component.scss', '../../secondary-nav.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        MenubarCollapseComponent,
        MenubarComponent,
        TopnavComponent,
        TopbarInfoComponent,
        TopbarContactInfoComponent,
        MenubarScrollComponent,
    ],
})
export class SecondaryNavContactsComponent {
    @Input() contactIn!: Contact;
    contactMenuItems?: NavMenuItem[];

    #navState = inject(SecondaryNavStoreService);
    #secondaryNavContactService = inject(SecondaryNavContactService);
    #layoutService = inject(LayoutService);
    #navService = inject(SecondaryNavService);
    #router = inject(Router);

    menuName = MenuName;
    isMobile$ = this.#layoutService.isMobile$;

    contact$ = this.#navState.currentContact.obs$;
    collapsed$ = this.#navState.navCollapsed.obs$;

    ngOnInit() {
        if (!this.contactIn) throw new TypeError('Contact is required');

        this.#navState.currentContact.set(this.contactIn);
        this.#navService.setCollapsedInitialState();
        this.contactMenuItems = this.#secondaryNavContactService.getMenuBarData();
    }

    back() {
        this.#router.navigate(['/contacts', 'list'], { queryParams: { subpanel: true } });
    }

    ngOnDestroy() {
        this.#navState.clearContact();
    }
}
